import { Stack } from 'component-library';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { SignedInPageLayout } from '@/layout/signed-in-page';
import { useMenuItems } from '@/pages/shared/hooks/useMenuItems';
import { PlotsDropdown } from '@/pages/shared/media-upload/components/PlotsDropdown';

export const MediaUploadPage = () => {
  const { t } = useTranslation();
  const menuItems = useMenuItems();

  return (
    <SignedInPageLayout
      items={menuItems}
      navBarProps={{
        title: t('navbar.mediaUpload'),
      }}
    >
      <Stack spacing={10}>
        <MediaSection title={t('navbar.plotOverview')}>
          <PlotsDropdown />
        </MediaSection>
      </Stack>
    </SignedInPageLayout>
  );
};

const MediaSection = ({ title, children }: { title: string; children: ReactNode }) => {
  return (
    <Stack spacing={6}>
      <span className='typography-h3 text-text-primary'>{title}</span>
      {children}
    </Stack>
  );
};
